/**
 * @ngdoc directive
 * @name Notification Comment Parser
 *
 */

(function() {
  app.service("notificationCommentParser", function() {
    var pattern = /\B@[a-z0-9_-]+/gi;

    this.parse = function(comment) {
      var mentions = comment.match(pattern);
      if (!mentions) {
        return comment;
      }
      return parseComment(angular.copy(comment), [], 0, mentions).join("");
    };

    function parseComment(comment, commentParsed, mentionIndex, mentions) {
      if (mentionIndex === mentions.length) {
        commentParsed.push(comment);
        return commentParsed;
      }

      var mention = mentions[mentionIndex];
      var parts = comment.split(mention);
      commentParsed.push(parts[0]);
      commentParsed.push("<b>" + mention + "</b>");
      return parseComment(parts[1], commentParsed, mentionIndex + 1, mentions);
    }
  });
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/notifications/notificationCommentParser.js